export const TOKEN_KEY = "epd_token";
export const MAX_RETRY_LOGIN = 5;
export const EPD_TIME_LIFE_KEY = "epd_time_life";
export const EPD_TIME_LIFE_VALUE = "1";
